export default {"src":"/_next/static/media/textile.074ce96e.svg","height":121,"width":121};